/* eslint-disable no-unused-vars */

import React, { useEffect, useMemo, useState } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { useSelector } from 'react-redux';

import DisabledLocation from '@components/location-toast';
import Map from './map';

import useDistance from '@hooks/useDistance';
import { GOOGLE_MAP_API_KEY } from '@utilities/app-urls';

import style from './style.module.scss';
import { useSearchParams } from 'react-router-dom';

const GoogleMapForSites = ({
  siteCoordinateList,
  detailPage = false,
  open,
  list,
  siteChildrenList = [],
  parentSiteDetailsPage = false
}) => {
  const [showNotifications, setShowNotifications] = useState(true);
  const [searchParams] = useSearchParams();

  const { coordinates } = useDistance({});
  const keyNameFilter = searchParams.get('keyName') || '';

  useEffect(() => {
    if (keyNameFilter === 'map') {
      setShowNotifications(true);

      setTimeout(() => {
        setShowNotifications(false);
      }, 3000);
    }
  }, [keyNameFilter]);

  const { showMapView = false, selectedSiteIdForMapView } =
    useSelector((state) => state.siteMap) || {};

  const { sitesMap = {}, sites: cacheSites = [] } = useSelector((state) => state.cache);

  const defaultCenterCoordinate = useMemo(() => {
    if (detailPage) {
      const findDefaultCenterCoordinate = siteCoordinateList?.find((x) => x?.default);
      if (findDefaultCenterCoordinate?.latitude) {
        return {
          latitude: findDefaultCenterCoordinate.latitude,
          longitude: findDefaultCenterCoordinate.longitude
        };
      } else {
        return coordinates;
      }
    } else {
      return coordinates;
    }
  }, [coordinates, siteCoordinateList, detailPage]);

  const selectedSiteCenterCoordinate = useMemo(() => {
    if (selectedSiteIdForMapView?.siteId) {
      let current = cacheSites[sitesMap[selectedSiteIdForMapView?.siteId]];
      return {
        latitude: current?.latitude,
        longitude: current?.longitude
      };
    } else {
      return null;
    }
  }, [showMapView, selectedSiteIdForMapView, sitesMap]);

  useEffect(() => {
    setTimeout(() => {
      setShowNotifications(false);
    }, 3000);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {(parentSiteDetailsPage || !detailPage) && (
        <DisabledLocation
          className={style.toastStyles}
          text="Only sites with GPS data appear in map view."
          showLocationDisabledInfo={showNotifications}
        />
      )}

      <APIProvider apiKey={GOOGLE_MAP_API_KEY}>
        <Map
          defaultCenterCoordinate={defaultCenterCoordinate}
          siteCoordinateList={siteCoordinateList}
          selectedSiteId={selectedSiteIdForMapView?.siteId}
          selectedSiteIndex={selectedSiteIdForMapView?.siteIndex}
          selectedSiteCenterCoordinate={selectedSiteCenterCoordinate}
          open={open}
          list={list}
          detailPage={detailPage}
          siteChildrenList={siteChildrenList}
        />
      </APIProvider>
    </div>
  );
};

export default GoogleMapForSites;
